export default function ViewAllFoldersIcon({
  width = 24,
  height = 24,
  strokeColor = 'currentColor',
  strokeWidth = 2
}: {
  width?: number;
  height?: number;
  strokeColor?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='mr-2'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      stroke={strokeColor}
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='M4 8c0-.6.5-1 1.1-1h13.8c.6 0 1.1.4 1.1 1 0 .2-.1.4-.2.6l-6.8 10.4a1 1 0 0 1-1.6 0L4.2 8.6a1 1 0 0 1-.2-.6z'
      />
    </svg>
  );
}
